import { render, staticRenderFns } from "./FullWidthImageCarousel.vue?vue&type=template&id=1a48c398"
import script from "./FullWidthImageCarousel.vue?vue&type=script&lang=js"
export * from "./FullWidthImageCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports